import { DrawingStateFns } from "./ModeContext";

export const inactiveModeFns: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        return [];
    },

    onKeyDown( drawMode, key, shift, ctx ) {
        return false; //we didn't handle it
    },

    onDeckClick( drawMode, info, ctx ) {        
        const ann = info?.object?.properties;
        if( ann ) {
            ctx.setSelObj( ann );
        }
    },

    onDeckHover( drawMode, info, ctx ) {
        //nothing to do in here right now        
    },

    onAnnotationClick( drawMode, ann, ctx ) {
        //in default mode we set it 
    },

    filter( drawMode, ann ) {
        return true;
    },
    
    getLineColor( drawMode, ann, ctx ) {
        const { obbAnnotationId: id, attributes: attrs } = ann;
        const done  = !( attrs.color === null || attrs.vehicleType === null );
        const alpha = id == ctx.hovObj?.obbAnnotationId ? 224 : 160;
        if( !done    ) { return [ 255, 255, 0, alpha ]; } //bright yellow
        if(  done    ) { return [   0, 255, 0, alpha ]; } //bright green
        return [255, 0, 0, 255];
    },

    getCursor( drawMode ) {
        return "grab";
    },

    getAnnotationLabel( drawMode, ann ) {
        return "";
    }
};